import { useEffect, useState } from 'react'

interface Props {
}

const useFullpage = () => {
  const [innerHeight, setInnerHeight] = useState(typeof window === 'undefined' ? 0 : window.innerHeight)
  // const [initScale, setInitScale] = useState(1)
  // const computeInitScale = () => {
  //   const wH = window.innerHeight;
  //   const wW = window.innerWidth;

  //   const hScale = wH / 40;
  //   const wScale = wW / 40;

  //   console.log({
  //     hScale,
  //     wScale,
  //   });

  //   const _scale = Math.max(hScale, wScale);

  //   console.log("computeInitScale", _scale);
  //   setInitScale(_scale);
  // };

  const handleResize = () => {
    setInnerHeight(window.innerHeight);
  };

  useEffect(() => {
    // setTimeout(() => {
    //   handleResize();
    // }, 2000);
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    innerHeight
  }
}

export default useFullpage
